import Observer from "../../../services/helpers/Observer";

export const EVENTS = {
    PROGRESSING: 'progressing',
    ENDED: 'ended'
}

export default class Ticker {
    _requestId = null;
    _currentTime = 0;
    _end = 0;
    observer = new Observer()

    start(isLoop = false) {
        if (this._requestId) return;

        let start = null;

        const handler = (timestamp) => {
            if (!start) start = timestamp - this._currentTime;

            this._currentTime = Math.floor(timestamp - start);

            if (this._end >= this._currentTime) {
                this._requestId = window.requestAnimationFrame(handler);
                
                this.observer.dispatch(EVENTS.PROGRESSING, this._currentTime);
            } else {
                this.reset();
                this.observer.dispatch(EVENTS.ENDED);

                if (isLoop) {
                    this.start(isLoop);
                }
            } 
        }

        this._requestId = window.requestAnimationFrame(handler);
    }

    stop() {
        cancelAnimationFrame(this._requestId);
        this._requestId = null;
    }

    reset() {
        cancelAnimationFrame(this._requestId);
        this._currentTime = 0;
        this._requestId = null;
    }

    setEnd(time) {
        this._end = time;
    }

    setCurrentTime(time) {
        this._currentTime = time;
        
        if (this._requestId) return;

        this.observer.dispatch(EVENTS.PROGRESSING, this._currentTime);
    }
} 